import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateUserCollectionGroupMutationVariables = Types.Exact<{
  data: Types.UpdateUserCollectionGroupInput;
}>;


export type UpdateUserCollectionGroupMutation = { updateUserCollectionGroup: { group: { id: string, name: string } } };


export const UpdateUserCollectionGroupDocument = /*#__PURE__*/ gql`
    mutation updateUserCollectionGroup($data: UpdateUserCollectionGroupInput!) {
  updateUserCollectionGroup(data: $data) {
    group {
      id
      name
    }
  }
}
    `;

export function useUpdateUserCollectionGroupMutation() {
  return Urql.useMutation<UpdateUserCollectionGroupMutation, UpdateUserCollectionGroupMutationVariables>(UpdateUserCollectionGroupDocument);
};